const ENABLE_LOGS = false;

class IaBlogRegular extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.blogHandle = this.dataset.blogHandle;
    this.currentPage = Number(this.dataset.currentPage);
    this.totalPages = Number(this.dataset.totalPages);
    
    this.grid = this.querySelector(".ia-blog-grid");
    this.button = this.querySelector("[data-ia-blog-regular-next]");
    this.buttonWrap = this.querySelector("[data-ia-blog-regular-controls]");
    
    if (this.button) {
      this.button.addEventListener("click", () => this.loadMore());
    }
    
    this.updateButton();
  }

  async loadMore() {
    if (this.currentPage >= this.totalPages) {
      this.hideButton();
      return;
    }

    this.button.disabled = true;
    
    try {
      const nextPage = this.currentPage + 1;
      const url = `/blogs/${this.blogHandle}?page=${nextPage}&section_id=${this.sectionId}`;
      
      this.log(`Fetching page ${nextPage}`);
      
      const res = await fetch(url, { 
        headers: { "X-Requested-With": "XMLHttpRequest" } 
      });
      
      if (!res.ok) {
        this.log(`Fetch failed: ${res.status}`);
        return;
      }
      
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      
      // Find this specific blog panel in the response
      const panel = doc.querySelector(`[data-ia-blog-panel][data-blog-handle="${this.blogHandle}"]`);
      
      if (!panel) {
        this.log("Panel not found in response");
        return;
      }
      
      // Get articles from the panel
      const items = panel.querySelectorAll("[data-ia-pagination-item]");
      
      if (items.length === 0) {
        this.log("No items found");
        this.currentPage = nextPage;
        this.updateButton();
        return;
      }
      
      // Append items to grid
      const fragment = document.createDocumentFragment();
      items.forEach(item => {
        fragment.appendChild(item.cloneNode(true));
      });
      
      this.grid.appendChild(fragment);
      this.log(`Loaded ${items.length} articles`);
      
      // Update pagination metadata from the response
      const paginationComponent = panel.querySelector("ia-blog-regular");
      if (paginationComponent) {
        this.currentPage = Number(paginationComponent.dataset.currentPage);
        this.totalPages = Number(paginationComponent.dataset.totalPages);
      } else {
        this.currentPage = nextPage;
      }
      
      this.updateButton();
      
      this.dispatchEvent(
        new CustomEvent("ia-blog-regular:items-appended", {
          bubbles: true,
          detail: { blogHandle: this.blogHandle, page: this.currentPage }
        })
      );
      
    } catch (err) {
      console.error("[ia-blog-regular] Error:", err);
    } finally {
      this.button.disabled = false;
    }
  }

  updateButton() {
    if (this.currentPage >= this.totalPages) {
      this.hideButton();
    }
  }

  hideButton() {
    if (this.buttonWrap) this.buttonWrap.style.display = 'none';
  }

  log(...args) {
    if (ENABLE_LOGS) console.log(`[ia-blog-regular:${this.blogHandle}]`, ...args);
  }
}

if (!customElements.get("ia-blog-regular")) {
  customElements.define("ia-blog-regular", IaBlogRegular);
}
